import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { DealerMenuItemDto, PotInjectionDto } from '@core/dtos'
import { GameHttp } from '@core/https'
import { AccountService, WebSocketService } from '@core/services'
import { ModalComponent, ModalV2Component } from '@shared/components'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-infuse-pot-modal',
  standalone: true,
  imports: [ModalComponent, FormsModule, SvgIconComponent, ModalV2Component, CommonModule],
  templateUrl: './infuse-pot-modal.component.html',
  styleUrl: './infuse-pot-modal.component.sass',
})
export class InfusePotModalComponent implements OnInit {
  @Input() showInjectPotModal = false
  @Input() dealerId: string
  @Output() closeEmitter = new EventEmitter()
  dealers: DealerMenuItemDto[] = []
  selectedTable: number = 0

  private readonly userId = this._accountService.currentUserId

  infusionAmount = 0

  constructor(
    private _webSocketService: WebSocketService,
    private _accountService: AccountService,
    private _gameHttp: GameHttp,
  ) {}

  ngOnInit(): void {
    this._gameHttp.getPlayerMenuInitData().subscribe((i) => {
      this.dealers = i.dealerMenuItems
    })
  }

  closeInfusePot() {
    this.infusionAmount = 0
    this.selectedTable = 0
    this.closeEmitter.emit()
  }

  confirm() {
    if (this.infusionAmount <= 0) {
      return
    }

    try {
      this._webSocketService.emitInjectPot({
        chips: this.infusionAmount,
        injectedByUserId: this.userId,
        tableId: this.selectedTable,
      } as PotInjectionDto)

      this.closeInfusePot()
    } catch (error) {
      console.log(error)
    }
  }
}
